import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild, Input} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import { MatTable } from '@angular/material/table';
//import {MatTableDataSource} from '@angular/material/table';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {TranslateService} from '@ngx-translate/core';

import { DialogBoxPrintComponentTablaDeEvaluacion } from './dialog-print-box.component';

//import { MatSort } from '@angular/material/sort';
import { TablaDeEvaluacion } from 'app/main/models/tabla-de-evaluacion.model';
import { Opcion } from 'app/main/models/opcion.model';

import {MatCalendar} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { replace } from 'lodash';
import { Router } from '@angular/router';

const ELEMENT_DATA: Opcion[] = [];


@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent {

  @Input() tipo: string = 'ANALISIS_DE_BRECHAS';
  @Input() title: string = 'criterio medición de brechas';
  href: string = "";

  action: string;
  LOCAL_DATA: any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  tiposTabla = ["EVALUACION_SIMPLE","EVALUACION_MULTIPLE"];
  tipoValor = null;
  tiposValor = ["CUMPLE_NO_CUMPLE","RANGO_VALORES"];

  new_line_p:Opcion = {id:null,descripcion:'',nombre:'',valor:0, valorMinimo:0, valorMaximo:0, esCumpleNoCumple:false, new:true};

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  displayedColumns: string[] = ['nombre','valor','descripcion','action'];
  displayedColumnsMultiple: string[] = ['nombre','valor','descripcion','action'];

  dataSource = ELEMENT_DATA;
  dataSourceMultiple = ELEMENT_DATA;

  @ViewChild('tableOpciones', {static: true}) tableOpciones: MatTable<any>;

  constructor(
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    public translate: TranslateService,
    public dialog: MatDialog,
    public router: Router,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

      this.href = this.router.url;
      //Es Debida diligencia
      if(this.href.indexOf('debida-diligencia')!=-1){
        this.tipo = "DEBIDA_DILIGENCIA";
        this.title = "Tablas de evaluación";
      }
      console.log(data);
      this.LOCAL_DATA = {...data};
      this.dataSource = data.opciones || [];
      this.action = this.LOCAL_DATA.action;
      this.dataSource.sort((a, b) => (a.valor < b.valor) ? 1 : -1);
      this.dataSource = [...this.dataSource];
      this.dataSourceMultiple = [...this.dataSource];
      this.LOCAL_DATA.tipoFiltro = this.tipo;

    if(this.dataSource.length>0)
      if(this.dataSource[0].esCumpleNoCumple)
        this.tipoValor = "CUMPLE_NO_CUMPLE";
      else
        this.tipoValor = "RANGO_VALORES";

    this.selectTipo();

    //Object.assign(this, { multi });
  }

  print():void{

    const dialogRef = this.dialog.open(DialogBoxPrintComponentTablaDeEvaluacion, {
      width: '100%',
      data: {action:"Print", obj:this.LOCAL_DATA},
      autoFocus: false
    });

  }

  doAction(): void{
    console.log('im here');
    if(this.LOCAL_DATA.tipo==="EVALUACION_SIMPLE")
      this.LOCAL_DATA.opciones = this.dataSource;
    else{

      if(this.tipoValor === "CUMPLE_NO_CUMPLE" || this.LOCAL_DATA.subtipo=="CUMPLE_NO_CUMPLE")
        this.dataSourceMultiple.forEach(element => {
          element.esCumpleNoCumple = true;
        });
      else
        this.dataSourceMultiple.forEach(element => {
          element.esCumpleNoCumple = false;
        });

      this.LOCAL_DATA.opciones = this.dataSourceMultiple;
    }

    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }


  remove(opcion: any): void {
    var index = -1;

    for(var i=0; this.dataSource.length>i;i++){
      if((opcion.id!=null &&  this.dataSource[i].id !=null &&
            opcion.nombre== this.dataSource[i].nombre) ||
          (opcion.nombre == this.dataSource[i].nombre)){
        index = i;
        break;
      }
    }

    if (index >= 0) {
      this.dataSource.splice(index, 1);
    }
    this.dataSource = [...this.dataSource];
    
  }

  removeMultiple(opcion: any): void {
    var index = -1;

    for(var i=0; this.dataSourceMultiple.length>i;i++){
      if((opcion.id!=null &&  this.dataSourceMultiple[i].id !=null &&
            opcion.nombre== this.dataSourceMultiple[i].nombre) ||
          (opcion.nombre == this.dataSourceMultiple[i].nombre)){
        index = i;
        break;
      }
    }

    if (index >= 0) {
      this.dataSourceMultiple.splice(index, 1);
    }
    this.dataSourceMultiple = [...this.dataSourceMultiple];
    
  }


  addLine():void{

    if(this.dataSource == undefined){
      this.dataSource = [];
    }

    if (this.new_line_p.new) {
      this.dataSource.push(this.new_line_p);
    }

    this.dataSource.sort((a, b) => (a.valor < b.valor) ? 1 : -1);

    this.dataSource = [...this.dataSource];

    this.new_line_p = {id:null,descripcion:'',nombre:'',valor:0,valorMinimo:0,valorMaximo:0,esCumpleNoCumple:false,new:true};

  }

  addLineMultiple():void{

    if(this.dataSourceMultiple == undefined){
      this.dataSourceMultiple = [];
    }

    if (this.new_line_p.new) {
      this.dataSourceMultiple.push(this.new_line_p);
    }

    this.dataSourceMultiple.sort((a, b) => (a.nombre < b.nombre) ? 1 : -1);

    this.dataSourceMultiple = [...this.dataSourceMultiple];

    this.new_line_p = {id:null,descripcion:'',nombre:'',valor:0,
                      valorMinimo:0,valorMaximo:0,
                      esCumpleNoCumple:this.tipoValor === "CUMPLE_NO_CUMPLE",
                      new:true};

  }


  edit(opcion: any):void{
    this.new_line_p = opcion;
    this.new_line_p.new = false;
  }


  ngOnInit(): void {

    //this.reloadChart();
  }

  selectTipo(): void{
    
    if(this.LOCAL_DATA.subtipo === "CUMPLE_NO_CUMPLE")
      this.displayedColumnsMultiple = ['nombre','descripcion','action'];
    else
      this.displayedColumnsMultiple = ['nombre','valorMinimo','valorMaximo','descripcion','action'];

  }



}
